import $ from 'jquery';
import { colors } from '../colors';
import { singleAxes, value } from '../options';

class MainAnalyticsCommonDynamics {
  constructor() {
  }

  // callback returns the chart as Base64Image
  static Chart(callback) {
    let ctx = $('#charts_main_analytics_common_dynamics')
    let check = $('canvas').is('#charts_main_analytics_common_dynamics')
    let project_id = $('[data-project-id]').data('project-id')
    let env = $('[data-env]').data('env')
    let options = singleAxes

    let first_week = parseUrl('start_week')
    let end_week = parseUrl('end_week')
    let days_from = parseUrl('days_from')
    let days_to = parseUrl('days_to')
    let period_filter_type = parseUrl('period_filter_type')
    let urlParams = 'project_id=' + project_id +
                    '&start_week=' + first_week +
                    '&end_week=' + end_week +
                    '&days_from=' + days_from +
                    '&days_to=' + days_to +
                    '&env=' + env +
                    '&period_filter_type=' + period_filter_type

    if(check) {
      $.ajax({
        url: '/api/v1/statistics/main_analytics_common_dynamics?' + urlParams,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          initChart(response)
        }
      });

      let initChart = function(response){
        if (response.participants.length == 0 &&
            (response.codes.length == 0 || response.receipts.length == 0) &&
            response.google_analytics.length == 0){
          $(ctx).parent().html('<div class="not_enough_data"><b>Для отображения недостаточно данных</b></div>')
          return;
        }

        let data = {
          labels: response.labels,

          datasets: [
            {
              type: "line",
              label: "Количество участников",
              data: response.participants,
              backgroundColor: colors.purple[300],
              hoverBackgroundColor: colors.purple[500],
              borderColor: colors.purple[500],
              hoverBorderColor: colors.purple[500],
              pointBackgroundColor: colors.purple[300],
              hoverPointBackgroundColor: colors.purple[500],
              pointBorderColor: colors.purple[500],
              hoverPointBorderColor: colors.purple[500],
              fill: false,
              datalabels: value
            },
            {
              type: "line",
              label: response.codes_receipts_label,
              data: response.codes_receipts,
              backgroundColor: colors.green[300],
              hoverBackgroundColor: colors.green[500],
              borderColor: colors.green[500],
              hoverBorderColor: colors.green[500],
              hoverPointBackgroundColor: colors.green[500],
              pointBorderColor: colors.green[500],
              hoverPointBorderColor: colors.green[500],
              fill: false,
              datalabels: value
            },
            {
              type: "line",
              label: "Количество посетителей (Google Analytics)",
              data: response.visitors,
              backgroundColor: colors.blue[300],
              hoverBackgroundColor: colors.blue[500],
              borderColor: colors.blue[500],
              hoverBorderColor: colors.blue[500],
              hoverPointBackgroundColor: colors.blue[500],
              pointBorderColor: colors.blue[500],
              hoverPointBorderColor: colors.blue[500],
              fill: false,
              datalabels: value
            }
          ]
        };

        options['legend']['display'] = true

        let animationOptions = {
          animation: {
            onComplete: function(){
              if (typeof callback == "function") {
                callback(newChart.toBase64Image());
              }
            }
          }
        }

        let newChart = new Chart(ctx, {
          type: "bar",
          data: {
            labels: data.labels,
            datasets: data.datasets
          },
          options: { ...options, ...animationOptions }
        });

        let showValue = true
        let newValueOptions = {}

        $('#main_analytics_common_dynamics_switch').on('click', function(){
          $(this).toggleClass('on')

          if(showValue == true)
          {
            showValue = false
            newValueOptions = {}
          }
          else
          {
            showValue = true
            newValueOptions = value
          }

          data.datasets.forEach(function(dataset) {
            dataset['datalabels'] = newValueOptions
          })

          newChart.update()
        })
      }
    }
  }

  static onInit() {
    MainAnalyticsCommonDynamics.Chart();
  }
}

export default MainAnalyticsCommonDynamics;
